import { useEffect, useState } from "react";
import api from "../api/axios.tsx";

export const useBalanceSummary = () => {
  const [balanceSummary, setBalanceSummary] = useState({
    balance: 0,
    expense: 0,
    income: 0,
    currency: "usd",
  });
  const user = JSON.parse(localStorage.getItem("user") || "{}");
  const userId = user?.id || ""; // Fallback to "default" if no user

  useEffect(() => {
    api
      .post("/transactions/balance_summary")
      .then((response) => {
        const fetchedSummary = response.data;
        setBalanceSummary(fetchedSummary);
      })
      .catch((error) => {
        console.error("Failed to fetch transactions:", error);
      });
  }, [userId]);

  return {
    balanceSummary,
  };
};
